import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { Survey, CharacteristicScore, Characteristic } from '../../models';
import { QuestionDataService, SurveyDataService, CharacteristicDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { TopNavMenu } from '../navigation/TopNavMenu';
import {CharacteristicScoreForm, LoadingIndicator, PVAPage} from '../../components';

interface CharacteristicScoreCreateState {
    characteristicScore: CharacteristicScore;
    survey: Survey | undefined;
    characteristicScores: CharacteristicScore[];
    characteristics: Characteristic[];
    defaultValues: any;
}

export class CharacteristicScoreCreate extends React.Component<BaseRouteProps<{ id: number }>, CharacteristicScoreCreateState> {
    private questionDataService = new QuestionDataService(this.props.notificationService);
    private surveyDataService = new SurveyDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            characteristicScore: new CharacteristicScore(),
            survey: undefined,
            characteristicScores: [],
            characteristics: [],
            defaultValues: {}
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        this.surveyDataService.get(this.props.match.params.id).then((survey: Survey) => {
            this.setState({
                survey: survey
            });
            this.characteristicDataService.getAll().then((characteristics: Characteristic[]) => {
                this.setState({
                    characteristics: characteristics
                });
            });
        });
    }

    public render() {

        return (
            <PVAPage>
                <PVAPage.Header>
                    <div className="title">Create Characteristic Score</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <CharacteristicScoreForm defaultValues={this.state.characteristicScore} submit={this.save} notificationService={this.props.notificationService} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        if (!this.state.survey) {
            return;
        }

        values.surveyId = this.state.survey.id;
        this.questionDataService.create(values).then((success) => {
            this.props.history.push('/question');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/characteristicscore/CharacteristicScoreCreate.tsx